/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $DeletedTableData = {
    description: `Deleted table data`,
    properties: {
        key: {
            description: `Deleted key`,
            properties: {
            },
            isRequired: true,
        },
        key_type: {
            type: 'string',
            description: `Deleted key type`,
            isRequired: true,
        },
    },
} as const;
